import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Overlay, Mask } from '@instructure/ui-overlays';
import t from '@instructure/quiz-i18n/format-message';
import { QuizzesSpinner as Spinner } from '../spinner/Spinner';
import CustomPropTypes from '../../../util/CustomPropTypes';
import { printWithCss, ensureImagesLoaded } from '../../../util/printUtils';
import PrintFontSizeModal from '../../PrintFontSizeModal';
import { PRINT_CURRENT_PAGE, PRINT_BLANK } from '@instructure/quiz-common';
export var PrintTrigger = /*#__PURE__*/function (_Component) {
  function PrintTrigger(props) {
    var _this2;
    _classCallCheck(this, PrintTrigger);
    _this2 = _callSuper(this, PrintTrigger, [props]);
    _defineProperty(_this2, "state", {
      waitingForPrintingToBeReady: false,
      printType: PRINT_CURRENT_PAGE,
      // quiz key or blank quiz
      shouldPrint: false
    });
    _defineProperty(_this2, "print", function () {
      printWithCss(_this2.fontSize, 100);
    });
    _defineProperty(_this2, "ensurePrintingIsReady", function (printFontSizeModalClose) {
      _this2.setState({
        waitingForPrintingToBeReady: true
      });
      var sampleItemFetchPromises = [];
      if (!_this2.props.isGrading) {
        var _this2$props = _this2.props,
          activeQuizId = _this2$props.activeQuizId,
          bankQuizEntryIds = _this2$props.bankQuizEntryIds,
          getSampleItemsForQuizEntry = _this2$props.getSampleItemsForQuizEntry;
        sampleItemFetchPromises = bankQuizEntryIds.map(function (bankQuizEntryId) {
          return getSampleItemsForQuizEntry(activeQuizId, bankQuizEntryId);
        });
      }
      var allPromises = [].concat(_toConsumableArray(sampleItemFetchPromises), [ensureImagesLoaded(), printFontSizeModalClose]);
      Promise.all(allPromises).then(function () {
        _this2.setState({
          waitingForPrintingToBeReady: false
        });
        _this2.onExited = function () {};
      });
    });
    _defineProperty(_this2, "handlePrintModalSubmit", function (fontSize, shouldPersist) {
      var printFontSizeModalClose = new Promise(function (resolve) {
        _this2.onExited = resolve;
      });
      _this2.props.closePrintFontSizeModal();
      if (shouldPersist) {
        _this2.props.persistPrintFontSize(fontSize);
      } else {
        _this2.props.setPrintFontSize(fontSize);
      }
      if (_this2.state.printType === PRINT_BLANK) {
        _this2.props.navigateToPreviewPrint();
      } else {
        _this2.fontSize = fontSize;
        _this2.ensurePrintingIsReady(printFontSizeModalClose);
      }
    });
    _defineProperty(_this2, "handlePrint", function (printType) {
      _this2.setState({
        printType: printType
      });
      _this2.props.openPrintFontSizeModal();
    });
    _this2.onExited = function () {};
    _this2.fontSize = '';
    return _this2;
  }
  _inherits(PrintTrigger, _Component);
  return _createClass(PrintTrigger, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Overlay, {
        open: this.state.waitingForPrintingToBeReady,
        shouldContainFocus: true,
        transition: "fade",
        onExited: this.print,
        label: t('Preparing Print Preview')
      }, /*#__PURE__*/React.createElement(Mask, null, /*#__PURE__*/React.createElement(Spinner, {
        mainText: t('Preparing Print Preview')
      }))), /*#__PURE__*/React.createElement(PrintFontSizeModal, {
        isOpen: this.props.printFontSizeModalOpen,
        onSubmit: this.handlePrintModalSubmit,
        onCancel: this.props.closePrintFontSizeModal,
        onExited: this.onExited,
        persistedPrintFontSize: this.props.persistedPrintFontSize
      }), this.props.render(this.handlePrint));
    }
  }]);
}(Component);
_defineProperty(PrintTrigger, "propTypes", {
  activeQuizId: PropTypes.string,
  appContainer: CustomPropTypes.selectors,
  bankQuizEntryIds: PropTypes.arrayOf(PropTypes.string),
  closePrintFontSizeModal: PropTypes.func.isRequired,
  getSampleItemsForQuizEntry: PropTypes.func.isRequired,
  isGrading: PropTypes.bool,
  navigateToPreviewPrint: PropTypes.func,
  openPrintFontSizeModal: PropTypes.func.isRequired,
  persistedPrintFontSize: PropTypes.string,
  persistPrintFontSize: PropTypes.func.isRequired,
  printFontSizeModalOpen: PropTypes.bool.isRequired,
  render: PropTypes.func.isRequired,
  setPrintFontSize: PropTypes.func.isRequired
});
_defineProperty(PrintTrigger, "defaultProps", {
  activeQuizId: null,
  appContainer: null,
  bankQuizEntryIds: [],
  isGrading: false,
  persistedPrintFontSize: 'medium',
  navigateToPreviewPrint: function navigateToPreviewPrint() {}
});
export default PrintTrigger;